module.exports = __webpack_public_path__ + "img/united-kingdom_flag.40865b70.png";